module.exports = __webpack_public_path__ + "static/pit_passes-8bc8feac9a5689e559b8cd2eda70526d.svg";